import type React from 'react';
import bgImage from '../../assets/img/construction-intelligence-header.optimized.jpg';
import logoImage from '../../assets/img/logo/lettermarkOrangeLG.png';

interface Props {
  children: React.ReactNode;
  rightSideContent?: React.ReactNode;
  'data-testid'?: string;
}

export default function Layout({ children, rightSideContent, 'data-testid': testId }: Props) {
  return (
    <div className="flex h-full w-full" data-testid={testId}>
      <div className="w-full p-4 pt-60 sm:w-1/2 lg:w-1/3">
        <div className="mb-8 flex w-full justify-center">
          <img className="w-60" src={logoImage} alt="CivilGrid Logo" />
        </div>
        {children}
      </div>
      <div
        className="hidden items-center justify-center bg-cover bg-center sm:flex sm:w-1/2 lg:w-2/3"
        style={{
          backgroundImage: `url(${bgImage})`,
          height: '100vh',
        }}
      >
        {rightSideContent}
      </div>
    </div>
  );
}
